import React, { Component } from 'react'
import '../../../App.css';
import { Layout, Button, Icon, Pagination } from 'antd';
import BgBanner from '../../../assets/images/banner/bg.png'
import List from '../../cell/List'
import SideBox from '../../cell/Side'
import { withTranslation } from 'react-i18next';
const { Content, Sider } = Layout;
const handleDown = () => {
    let url = window.location.host;
    // let dlLocation = 'es-ygj.digiwincloud.com.cn'//大陆
    let twLocation = 'es-ygj.digiwincloud.com'//台湾
    if (url === twLocation) { //台湾
        //window.location.href = 'https://es-update.digiwin.com/installer/SCP/鼎新服務雲管家使用說明.docx'//台湾的云管家下载地址
        window.location.href = 'https://es-update.digiwin.com/installer/SCP/鼎新服務雲管家使用說明.pdf'//台湾的云管家下载地址
    } else {
        //window.location.href = 'http://es-update.digiwincloud.com.cn/installer/鼎捷服务云管家操作手册.docx'//大陆的云管家下载地址
        window.location.href = 'https://es-repo.digiwincloud.com.cn/installer/鼎捷服务云管家操作手册.pdf' // 'http://es-update.digiwincloud.com.cn/installer/鼎捷服务云管家操作手册.pdf'//大陆的云管家下载地址
    }
    //註:Word檔在對應路徑下，以有日期之檔案為主，現行最新的為_20250207.docx
};
class CommonProblem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            problemLists: [
                {
                    // url:imgProblem01,
                    title: 'common_detail_title01',
                    content: 'common_detail_content01',
                    id: 1
                },
                {
                    // url:imgProblem02,
                    title: 'common_detail_title02',
                    content: 'common_detail_content02',
                    id: 2
                },
                {
                    // url:imgProblem02,
                    title: 'common_detail_title03',
                    content: 'common_detail_content03',
                    id: 3
                },
                {
                    // url:imgProblem02,
                    title: 'common_detail_title04',
                    content: 'common_detail_content04',
                    id: 4
                },
                {
                    // url:imgProblem02,
                    title: 'common_detail_title05',
                    content: 'common_detail_content05',
                    id: 5
                },
                {
                    // url:imgProblem02,
                    title: 'common_detail_title06',
                    content: 'common_detail_content06',
                    id: 6
                },
            ],
            current: 1,
            id: 1
        }
        this.handleClick = this.handleClick.bind(this)
    }
    onChange = (page) => {
        this.setState({
            current: page,
        });
    }
    handleClick(id) {
        // this.props.history.push({ pathname: "/commonProblem/detail",  type:id})
        this.props.history.push({ pathname: "/commonProblem/detail/", search: "?type=" + id })
    }
    render() {
        const { t } = this.props
        return (
            <Content className="q-content-wrapper">
                <div className="q-main" style={{ padding: '65px' }}>
                    <div className="q-fix-width">
                        <Layout>
                            <Content className="q-detail-content q-content-border q-padding-50">
                                <div className="common-bg-sect">
                                    <div className="common-bg-detail">
                                        <h2>{t('newbie')}</h2>
                                        <div className="common-bg-detail_box">
                                            <h3>{t('cmp_handbook')}</h3>
                                            <Button type="" className="common-button" size="large" onClick={handleDown}>
                                                <Icon type="download" />
                                                {t('button_download')}
                                            </Button>
                                        </div>
                                        {/* <span className="bg-opacity"></span> */}
                                    </div>
                                    <img className="common-bg-banner" src={BgBanner} alt="" />
                                </div>
                                <div className="common-bg-content">
                                    <List problemLists={this.state.problemLists} handleClick={this.handleClick} />
                                </div>
                                {
                                    this.state.problemLists.length > 10 ?
                                        <Pagination style={{ textAlign: 'right' }} onChange={this.onChange} defaultCurrent={1} total={50} />
                                        : ''
                                }
                            </Content>
                            <Sider theme="light" className="q-detail-sider">
                                <SideBox type='1' />
                            </Sider>
                        </Layout>

                    </div>
                </div>
            </Content>
        )
    }
}
export default withTranslation()(CommonProblem)